<template>
    <div class="venue">
        <TitlePart text="The Hong Kong Polytechnic University"/>
        <div class="left-aligned-text">
            <p style="line-height:150%; text-align:justify">The Hong Kong Polytechnic University (PolyU) is located at the centre of the city. 
                The venues is nearby and is easily accessible via various transportation.</p>
        </div>
        <div>
            <a href="https://www.polyu.edu.hk/campus-map/">
                <img src="@/assets/CampusMap1.jpg" alt style="width: 80%; margin-top: 10px;">
            </a>
        </div>
        <div class="left-aligned-text" style="margin-top: 10px;">
            <h3>By MTR</h3>
            <p style="line-height:150%; text-align:justify">The nearest MTR station is Hung Hom Station and a footbridge at Exit A1 or D1 leads you to the campus.</p>
            <h3>By Bus</h3>
            <p style="line-height:150%; text-align:justify">Two major bus stops around campus are Hung Hom Station and Cross Harbour Tunnel Toll Plaza (Kowloon side).</p>
            <h3>By Taxi</h3>
            <p style="line-height:150%; text-align:justify">Three types of taxis are operating in Hong Kong: Urban red taxi, New Territories green taxi, 
                and Lantau Island blue taxi. All three types of taxis serve Hong Kong International Airport, but only Urban red taxis go to PolyU. 
                Details for taxi fare are available  <a href="https://www.td.gov.hk/en/transport_in_hong_kong/public_transport/taxi/">here</a> Additional charges occur for large baggage. 
                The tunnel tolls are both payable by a passenger for cross-harbour hiring.</p>
        </div>
        <TitlePart text="From the Airport to PolyU"/>
        <div class="left-aligned-text">
            <h3>By MTR</h3>
            <p style="line-height:150%; text-align:justify">First, take Airport Express from Hong Kong International Airport to Tsing Yi Station. Next, 
                interchange at Tsing Yi Station Platform 4 to Tung Chung Line (towards Hong Kong Station). 
                Then, interchange at Nam Cheong Station Platform 2 to Tuen Ma Line (to Wu Kai Sha Station). 
                Get off at Hung Hom Station and take the footbridge at Exit A1 or D1 to the campus. 
                A single journey takes around 40 minutes for the ride, and costs HK$65 (with Octopus) / HK$70 (without Octopus). 
                Please refer to the <a href="https://www.mtr.com.hk/en/customer/jp/index.php?oLabel=Airport&oType=HRStation&oValue=47&dLabel=Hung%20Hom&dType=HRStation&dValue=64">MTR website</a> for details.</p>
            <h3>By Bus</h3>
            <p style="line-height:150%; text-align:justify">Take Cityflyer route A21 from Airport (Ground Transportation Centre) Bus Terminus to Hung Hom Station. 
                Take the footbridge at Hung Hom Station Exit D1 or A1 that leads you to the campus. It takes around 75 mins for the ride and costs HK$33. 
                Please refer to the <a href="https://www.citybus.com.hk/routes/airport-bus/route/index.aspx?intLangID=1">Citybus & NWFB website</a> for details.</p>
        </div>
        <TitlePart text="From Inland China and Macao to PolyU"/>
        <div class="left-aligned-text">
            <h3>By High Speed Rail (Hong Kong Section)</h3>
            <p style="line-height:150%; text-align:justify">The Hong Speed Rail (Hong Kong Section) runs from Hong Kong West Kowloon Station, 
                connecting Hong Kong with Inland China's national high-speed rail network. 
                Please refer to the <a href="https://www.highspeed.mtr.com.hk/en/main/index.html">MTR High Speed Rail website</a> for details. 
                To ensure timely departure, passengers are advised to allow sufficient time for completing security checks and immigration formalities at Hong Kong West Kowloon Station. 
                Normally, travellers can complete the above procedures smoothly within 30 minutes. 
                Passport holders or travellers using traditional immigration counters may require additional time for clearance process. 
                After clearance, first, get off at Hong Kong West Kowloon Station and get on the train at Austin. 
                Passenger can reach the destination via overhead bridge/ pedestrian tunnel. 
                Next, interchange at Austin Platform 2 to Tune Ma Line (towards Wu Kai Sha Station). 
                Get off at Hung Hom Station and take the footbridge at Exit A1 or D1 to the campus. 
                A single journey (from Austin Station to Hung Hom Station) takes around 7 minutes for the ride, and costs HK$5.9 (with Octopus) / HK$6.5 (without Octopus). 
                Please refer to the <a href="https://www.mtr.com.hk/en/customer/jp/index.php?oLabel=Austin&oType=HRStation&oValue=111&dLabel=Hung%20Hom&dType=HRStation&dValue=64">MTR website</a> for details.</p>
            <h3>Via Hong Kong-Zhuhai-Macao Bridge (HZMB)</h3>
            <p style="line-height:150%; text-align:justify">The Hong Kong-Zhuhai-Macao Bridge operates 24 hours a day and puts major cities in the Pearl River Delta within a three hours' commute from Hong Kong. 
                It will take only 40 minutes to travel the distance of approximately 42km from Zhuhai Port and Macao Port to Hong Kong Port. 
                Cross-boundary visitors should possess a valid travel document. 
                Non-cross-boundary travellers should possess a valid Closed Area Permit for entering the Closed Area of the HZMB Hong Kong Port.
            </p>
            <p style="line-height:150%; text-align:justify">
                For details of local public transport serving the Hong Kong Port, 
                please refer to the <a href="https://www.hzmb.gov.hk/en/">HZMB website</a> and the <a href="https://www.td.gov.hk/en/home/index.html">HKSAR Transport Department website</a>.
            </p>
        </div>
        <br>
        <br>
        <br>
    </div>
</template>


<script>
import TitlePart from '@/components/TitlePart/TitlePart.vue'
    export default {
        components:{
            TitlePart
        }
    }
</script>

<style lang="less" scoped>
    @import "./style.less" ;
</style>